import React, { useMemo } from 'react'

import { Option } from '../../models/Option'
import { PSComponent } from '../../models/PSComponent'
import { RecordFactory } from '../../models/RecordFactory'
import { ComponentData } from '../../utils/typing'
import { PocketComponent, PocketComponentProps, usePSComponent } from '../PocketComponent'
import { ReportSelectModal } from './ReportSelectModal'

type ReportSelectMetricModalProps = {
    selected: PSComponent | undefined
    metricData: PSComponent[]
    onSelect: (option: Option) => void
    onClose: () => void
    onBack?: () => void
}

const viewWillAppear = async (base: PocketComponent<ReportSelectMetricModalProps>) => {
    return {
        measures: await RecordFactory.getInstance().loadComponents('measure'),
    }
}

const render = ({
    data: { measures },
    base: {
        props: { selected, metricData, onSelect, onClose, onBack },
    },
}: PocketComponentProps<ComponentData<typeof viewWillAppear>, ReportSelectMetricModalProps>) => {
    const options = useMemo(() => {
        const l: Option[] = []
        const groups: { [key: string]: PSComponent[] } = {}
        for (const component of measures) {
            const groupKey = component.grouping || ''
            groups[groupKey] = groups[groupKey] || []
            groups[groupKey].push(component)
        }

        const keys = [...PSComponent.groupingOrder]
        for (const key in groups) {
            if (!keys.includes(key)) {
                keys.push(key)
            }
        }

        for (const groupKey of keys) {
            const components = groups[groupKey]
            const nameForKey =
                groupKey === 'income'
                    ? 'Income'
                    : groupKey === 'booking'
                      ? 'Bookings'
                      : groupKey === 'client'
                        ? 'Clients'
                        : 'Other'
            for (const component of components) {
                if (
                    component.id === selected?.id ||
                    !metricData.map((x) => x.id).includes(component.id)
                ) {
                    l.push(
                        new Option(undefined, {
                            id: component.id,
                            label: component.title,
                            group: nameForKey,
                            subtitle: component.memo,
                        })
                    )
                }
            }
        }
        return l
    }, [selected, metricData])

    return (
        <ReportSelectModal
            title={selected ? 'Edit metric' : 'Add metric'}
            selectValues={options}
            selectedValue={selected?.id}
            onSelect={onSelect}
            onClose={onClose}
            onBack={onBack}
        />
    )
}

export const ReportSelectMetricModal = usePSComponent(render, viewWillAppear)
